module.exports = __webpack_public_path__ + "img/Front Barbell.f450a82d.png";